export enum LoadingStatus {
  IDLE = "idle",
  LOADING = "loading",
  LOADED = "loaded",
  ERRORED = "errored",
}
